import React from 'react';
import { UserHeader } from '../../../../shared/layout/header/UserHeader';
import { PageLayout } from '../../../../shared/layout/page/PageLayout';
import { IHeaderProps } from '../../../../shared/layout/header/Header';

interface IBookingPageLayoutProps extends IHeaderProps {}

export const BookingPageLayout = ({
	children,
	...rest
}: IBookingPageLayoutProps) => (
	<PageLayout hideFooterOnMobile>
		<UserHeader theme="green-blue" {...rest} />
		{children}
	</PageLayout>
);
